var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("app-detail-header", {
        attrs: {
          "show-toggle": true,
          "show-delete": false,
          "show-save": _vm.enableSave,
          "show-cancel": false,
          "show-new": false,
          "show-print": false,
        },
        on: { appDetailHeaderButtonClicked: _vm.onHeaderButtonClicked },
      }),
      _c("div", { staticClass: "columns is-gapless" }, [
        _c(
          "div",
          { staticClass: "column is-narrow" },
          [
            _vm.companySetting
              ? _c("gst-report-side-menu", {
                  attrs: { "gst-period": _vm.gstPeriod },
                  on: {
                    printWH: _vm.openWithHoldingModal,
                    reprint: _vm.openReprintModal,
                    print: _vm.openPrintModal,
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _c("div", { staticClass: "column" }, [
          !_vm.gstPeriod
            ? _c("div", { staticClass: "tile is-parent" }, [_vm._m(0)])
            : _vm._e(),
          _c("div", { staticClass: "tile is-parent" }, [
            _c("article", { staticClass: "tile is-child box" }, [
              _c("div", { staticClass: "tabs is-boxed" }, [
                _vm.reports
                  ? _c(
                      "ul",
                      _vm._l(_vm.reports, function (report) {
                        return _c(
                          "li",
                          {
                            key: report.parameterId,
                            class: {
                              "is-active": _vm.reportType === report.reportName,
                            },
                          },
                          [
                            _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.tabClicked(report.reportName)
                                  },
                                },
                              },
                              [
                                _c("span", [
                                  _c("span", [
                                    _vm._v(_vm._s(report.reportTitle)),
                                  ]),
                                ]),
                              ]
                            ),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
              ]),
              _vm.loadReport
                ? _c(
                    "div",
                    _vm._l(_vm.reports, function (report) {
                      return _c(
                        "div",
                        { key: report.parameterId },
                        [
                          _c("print-preview-without-header", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: report.reportName == _vm.reportType,
                                expression: "report.reportName==reportType",
                              },
                            ],
                            attrs: {
                              "report-name": report.reportName,
                              parameters: report.parameters,
                              "parameter-id": report.parameterId,
                            },
                            on: {
                              loadFinish: function ($event) {
                                return _vm.loadFinish()
                              },
                            },
                          }),
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _c(
                    "div",
                    { staticClass: "content has-text-grey has-text-centered" },
                    [_vm._m(1), _c("p", [_vm._v("No report to show")])]
                  ),
            ]),
          ]),
        ]),
      ]),
      _vm.isGstWithHoldingModalActive
        ? _c(
            "gst-with-holding-statement-modal",
            {
              attrs: {
                active: _vm.isGstWithHoldingModalActive,
                "show-icon": false,
              },
              on: {
                "update:active": function ($event) {
                  _vm.isGstWithHoldingModalActive = $event
                },
                close: function ($event) {
                  return _vm.closeWithHoldModal()
                },
                print: _vm.printWH,
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Print With-Holding Statement"),
              ]),
              _vm._v("/> "),
            ]
          )
        : _vm._e(),
      _vm.isGstReprintModalActive
        ? _c(
            "gst-reprint-modal",
            {
              attrs: {
                active: _vm.isGstReprintModalActive,
                "show-icon": false,
                "gst-basis": _vm.gstBasis,
              },
              on: {
                "update:active": function ($event) {
                  _vm.isGstReprintModalActive = $event
                },
                close: function ($event) {
                  return _vm.closeReprintModal()
                },
                print: _vm.rePrint,
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Reprint Previous Gst Report"),
              ]),
              _vm._v("/> "),
            ]
          )
        : _vm._e(),
      _vm.isGstPrintModalActive
        ? _c(
            "gst-print-modal",
            {
              attrs: {
                active: _vm.isGstPrintModalActive,
                "show-icon": false,
                "gst-basis": _vm.gstBasis,
                "selected-month": _vm.selectedMonth,
              },
              on: {
                "update:active": function ($event) {
                  _vm.isGstPrintModalActive = $event
                },
                close: function ($event) {
                  return _vm.closePrintModal()
                },
                print: _vm.print,
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Reports to Print"),
              ]),
              _vm._v("/> "),
            ]
          )
        : _vm._e(),
      _vm.isGstPayWHModalActive
        ? _c(
            "gst-pay-with-holding-modal",
            {
              attrs: {
                active: _vm.isGstPayWHModalActive,
                "company-setting": _vm.companySetting,
                "gst-basis": _vm.gstBasis,
                "selected-month": _vm.selectedMonth,
              },
              on: {
                "update:active": function ($event) {
                  _vm.isGstPayWHModalActive = $event
                },
                close: function ($event) {
                  return _vm.closePayGstModal()
                },
                saveSuccess: function ($event) {
                  return _vm.saveSuccess()
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Pay GST/With-Holding"),
              ]),
              _vm._v("/> "),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("article", { staticClass: "message is-warning tile is-child" }, [
      _c("div", { staticClass: "message-body" }, [
        _vm._v(" GST period has not been set up, please go to "),
        _c("strong", [
          _vm._v("Admin "),
          _c("i", { staticClass: "mdi mdi-arrow-right" }),
          _vm._v(" Company"),
        ]),
        _vm._v(". "),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { attrs: { icon: "icon is-large" } }, [
      _c("i", { staticClass: "mdi mdi-48px mdi-emoticon-sad" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }